(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trd-acemate-gift-only"] && !Shopify.designMode) return;
  try {
    if (!window.trdKiteGiftSubmitInstalled) {
    window.trdKiteGiftSubmitInstalled = true;
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const offer = form.querySelector('[data-trd-kite-submit]');
      if (!offer) return;
      const data = new FormData(form);
      const mainId = Number(data.get('id'));
      const giftMap = {47739899805910: 50413903610070, 47739899838678: 50413903610070, 47739899871446: 50413903610070, 50330081657046: 50408891318486, 47564164137174: 50389667709142, 47739539259606: 50389591752918, 47736568643798: 50389591785686, 50232502911190: 50520526880982};
      const recentGiftMap = {50516265205974:50517230420182,50516265238742:50517230420182,50516265271510:50517230420182,50516265304278:50517230420182,50516273791190:50517239922902,50516273823958:50517239922902,50516273856726:50517239922902,50516273889494:50517239922902,50516273922262:50517239922902,50516276019414:50517241757910,50516276052182:50517241757910,50516276084950:50517241757910,50516271530198:50517230387414,50516271562966:50517230387414,50520555716822:50520582127830,50520555749590:50520582127830};
      const recentOffer = Boolean(recentGiftMap[mainId]);
      if (Date.now() >= Date.parse(recentOffer ? '2026-10-16T04:00:00Z' : '2026-10-01T04:00:00Z')) return;
      const giftId = recentGiftMap[mainId] || giftMap[mainId];
      const chasingGifts = {50389591752918: [47739539259606], 50389591785686: [47736568643798], 50413903610070: [47739899805910, 47739899838678, 47739899871446], 50520526880982: [50232502911190]};
      const isChasing = Object.values(chasingGifts).some(robots => robots.includes(mainId));
      if (!giftId || data.get('selling_plan')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.trdKiteBusy === 'true') return;
      const quantity = Number(data.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) {
        offer.textContent = offer.dataset.error;
        offer.hidden = false;
        return;
      }
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const disabledBefore = buttons.map(button => button.disabled);
      form.dataset.trdKiteBusy = 'true';
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => button.disabled = true);
      offer.hidden = true;
      try {
        const cartResponse = await fetch(offer.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}});
        if (!cartResponse.ok) throw new Error(offer.dataset.error);
        const cart = await cartResponse.json();
        const properties = {};
        for (const [key, value] of data.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        let items = [{id: mainId, quantity, properties}];
        if (recentOffer) {
          const scope = form.closest('.product--section') || form;
          const extras = Array.from(scope.querySelectorAll('.ch-kit input[type="checkbox"]:checked'));
          items.push(...extras.filter(input => Number(input.value) !== giftId).map(input => ({id:Number(input.value),quantity:1})));
          if (!form.dataset.trdKitePlan) {
            form.dataset.trdKitePlan = JSON.stringify(items.map(item => ({...item,target:cart.items.filter(line => line.variant_id === item.id).reduce((sum,line) => sum + line.quantity,0) + item.quantity})));
          }
          items = JSON.parse(form.dataset.trdKitePlan).map(item => ({id:item.id,properties:item.properties,quantity:Math.max(0,item.target-cart.items.filter(line => line.variant_id === item.id).reduce((sum,line)=>sum+line.quantity,0))})).filter(item=>item.quantity>0);
        }
        if (mainId === 50232502911190) items.push({id: giftId, quantity: 1});
        if (items.length) {
        const response = await fetch(offer.dataset.cartUrl + '/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || offer.dataset.error);
        }
        let claimed = false;
        for (let attempt = 0; attempt < 40; attempt++) {
          const verifiedResponse = await fetch(offer.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}});
          if (!verifiedResponse.ok) throw new Error(offer.dataset.error);
          const verified = await verifiedResponse.json();
          const hasMatchingGift = verified.items.some(item => item.variant_id === giftId && item.quantity === 1 && item.final_line_price === 0);
          const hasOtherChasingGift = isChasing && verified.items.some(item => chasingGifts[item.variant_id] && item.quantity === 1 && item.final_line_price === 0 && verified.items.some(robot => chasingGifts[item.variant_id].includes(robot.variant_id) && robot.quantity > 0));
          if (hasMatchingGift || hasOtherChasingGift) {
            window.location.assign(offer.dataset.cartUrl);
            return;
          }
          const claim = form.querySelector('.gfgFGv2-row-unlocked .gfgFGv2-btn:not(.gfgFGv2-btn-remove)');
          if (!claimed && claim && !claim.disabled) {
            claim.click();
            claimed = true;
          }
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        throw new Error(offer.dataset.error);
      } catch (failure) {
        offer.textContent = failure.message || offer.dataset.error;
        offer.hidden = false;
      } finally {
        form.dataset.trdKiteBusy = 'false';
        form.removeAttribute('aria-busy');
        buttons.forEach((button, index) => button.disabled = disabledBefore[index]);
      }
    }, true);
  }
  (() => {
    const root = document.querySelector('[data-trd-acemate-only]');
    if (!root || root.dataset.installed) return;
    root.dataset.installed = 'true';
    const form = root.closest('form');
    if (!form) return;
    const giftRules = {
      50385477501142: { group: 'acemate', robots: [48239014281430, 50520501158102] },
      50385477599446: { group: 'acemate', robots: [48239014281430, 50520501158102] },
      50389667709142: { group: 'terramow', robot: 47564164137174 },
      50389591752918: { group: 'chasing', robot: 47739539259606 },
      50389591785686: { group: 'chasing', robot: 47736568643798 },
      50413903610070: { group: 'chasing', robots: [47739899805910, 47739899838678, 47739899871446] },
      50408891318486: { group: 'aceiilab', robot: 50330081657046 },
      50520526880982: { group: 'chasing', robot: 50232502911190 }
    };
    let running;
    let allowCheckout = false;
    let queued;
    const request = async (suffix, body) => {
      const response = await fetch(root.dataset.cartUrl + suffix, {
        method: body ? 'POST' : 'GET',
        headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error(root.dataset.error);
      return response.json();
    };
    const check = () => {
      if (running) return running;
      running = (async () => {
        try {
          const cart = await request('.js');
          const kept = new Set();
          const updates = {};
          cart.items.forEach(item => {
            const rule = giftRules[item.variant_id];
            if (!rule) return;
            const hasRobot = cart.items.some(robot => (rule.robots || [rule.robot]).includes(robot.variant_id) && robot.quantity > 0);
            if (hasRobot && !kept.has(rule.group) && item.quantity === 1 && item.final_line_price === 0) kept.add(rule.group);
            else updates[item.key] = 0;
          });
          if (Object.keys(updates).length) {
            const note = form.querySelector('[name="note"]');
            await request('/update.js', { updates, ...(note ? { note: note.value } : {}) });
            try { sessionStorage.setItem('trd-acemate-gift-removed', '1'); } catch (_) {}
            window.location.reload();
            return false;
          }
          return true;
        } catch (_) {
          root.hidden = false;
          root.querySelector('[role="status"]').textContent = root.dataset.error;
          return false;
        } finally { running = null; }
      })();
      return running;
    };
    const guard = async event => {
      if (allowCheckout) return;
      const button = event.type === 'click' ? event.target.closest('button[name="checkout"]') : event.submitter;
      if (!button || button.form !== form || button.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (await check()) { allowCheckout = true; form.requestSubmit(button); }
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    const items = form.querySelector('.cartitems--container');
    if (items) new MutationObserver(() => {
      clearTimeout(queued);
      queued = setTimeout(check, 400);
    }).observe(items, { childList: true, subtree: true });
    try {
      if (sessionStorage.getItem('trd-acemate-gift-removed')) {
        root.hidden = false;
        root.querySelector('[role="status"]').textContent = root.dataset.removed;
        sessionStorage.removeItem('trd-acemate-gift-removed');
      }
    } catch (_) {}
    check();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-acemate-gift-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const picker = form.querySelector('[data-trd-acemate-picker]');
  if (!picker || Date.now() >= Date.parse('2026-10-16T04:00:00Z')) return;
  const data = new FormData(form);
  const id = Number(data.get('id'));
  if (![48239014281430, 50520501158102].includes(id)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (form.dataset.trdGiftBusy) return;
  const giftId = Number(data.get('trd_acemate_gift'));
  const quantity = Number(data.get('quantity') || 1);
  const error = picker.querySelector('[data-trd-acemate-picker-error]');
  error.hidden = true;
  const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
  const disabled = buttons.map(button => button.disabled);
  form.dataset.trdGiftBusy = 'true';
  buttons.forEach(button => button.disabled = true);
  try {
    if (!Number.isInteger(quantity) || quantity < 1 || ![50385477501142, 50385477599446].includes(giftId)) throw new Error(picker.dataset.error);
    const cartResponse = await fetch(picker.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
    if (!cartResponse.ok) throw new Error(picker.dataset.error);
    const cart = await cartResponse.json();
    const properties = {};
    for (const [key,value] of data.entries()) {
      if (key.startsWith('properties[') && key.endsWith(']') && typeof value === 'string') properties[key.slice(11,-1)] = value;
    }
    const currentQuantity = cart.items.filter(item => item.variant_id === id).reduce((sum,item) => sum + item.quantity, 0);
    if (!form.dataset.trdGiftExpectedQuantity) form.dataset.trdGiftExpectedQuantity = String(currentQuantity + quantity);
    const missingQuantity = Math.max(0, Number(form.dataset.trdGiftExpectedQuantity) - currentQuantity);
    const items = [{id, quantity: missingQuantity, properties}];
    if (missingQuantity > 0) {
    const response = await fetch(picker.dataset.cartUrl + '/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || picker.dataset.error);
    }
    let claimed = false;
    for (let attempt = 0; attempt < 40; attempt++) {
      const verifyResponse = await fetch(picker.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
      if (!verifyResponse.ok) throw new Error(picker.dataset.error);
      const verified = await verifyResponse.json();
      if (verified.items.some(item => [50385477501142,50385477599446].includes(item.variant_id) && item.quantity === 1 && item.final_line_price === 0)) {
        window.location.assign(picker.dataset.cartUrl);
        return;
      }
      const wanted = giftId === 50385477501142 ? 'Acemate Extra Battery' : 'Acemate Mecanum Wheels';
      const row = Array.from(form.querySelectorAll('.gfgFGv2-row-unlocked')).find(item => item.querySelector('img')?.alt.startsWith(wanted));
      const claim = row?.querySelector('.gfgFGv2-btn-add');
      if (!claimed && claim && !claim.disabled) { claimed = true; claim.click(); }
      await new Promise(resolve => setTimeout(resolve, 400));
    }
    throw new Error(picker.dataset.error);
  } catch (failure) {
    error.textContent = failure.message || picker.dataset.error;
    error.hidden = false;
  } finally {
    delete form.dataset.trdGiftBusy;
    buttons.forEach((button,index) => button.disabled = disabled[index]);
  }
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-yarbo-cart-gift"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-trd-cart-gift]');
    if (!root || root.dataset.installed) return;
    root.dataset.installed = 'true';
    const form = root.closest('form');
    const status = root.querySelector('[data-cart-gift-status]');
    const retry = root.querySelector('[data-cart-gift-retry]');
    const giftIds = [50382698741974, 50382700085462];
    const eligibility = {
  "50382698741974": [
    47259631845590,
    47259647410390,
    48360806580438,
    48360810938582,
    50409005121750,
    50409143730390,
    50409143828694,
    50409143861462,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ],
  "50382700085462": [
    47259649442006,
    48360804450518,
    48360806744278,
    48360811528406,
    50409005482198,
    50409005973718,
    50409143795926,
    50409145041110,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ]
};
    let running = null;
    let allowCheckout = false;
    let queued = null;
    let pendingPreference;
    let needsReload = false;
    const optOutKey = '_trd_yarbo_gift_opt_out';
    const request = async (suffix, body) => {
      const response = await fetch(root.dataset.cartUrl + suffix, {
        method: body ? 'POST' : 'GET',
        headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(root.dataset.error);
      return result;
    };
    const planGift = (cart, preferred, active) => {
      const allowed = active ? giftIds.filter(id => cart.items.some(item => eligibility[id].includes(item.variant_id))) : [];
      const managed = cart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
      const existing = cart.items.find(item => allowed.includes(item.variant_id) && (!preferred || item.variant_id === preferred) && (managed.includes(item) || item.final_line_price === 0));
      const optedOut = preferred === 0 || (preferred === undefined && cart.attributes && cart.attributes[optOutKey] === '1');
      const chosen = optedOut ? undefined : (existing ? existing.variant_id : (allowed.includes(preferred) ? preferred : allowed[0]));
      const updates = {};
      managed.forEach(item => {
        const wanted = !optedOut && item === existing ? 1 : 0;
        if (item.quantity !== wanted) updates[item.key] = wanted;
      });
      const system = chosen && cart.items.find(item => eligibility[chosen].includes(item.variant_id));
      return { chosen, updates, optedOut, allowed, add: chosen && !existing ? { id: chosen, quantity: 1, properties: { _trd_gift_for: String(system.variant_id) } } : null };
    };
    const reconcile = preferred => {
      if (running) {
        if (preferred !== undefined) pendingPreference = preferred;
        return running;
      }
      running = (async () => {
        const checkoutButtons = [...form.querySelectorAll('button[name="checkout"]')];
        const disabledBefore = checkoutButtons.map(button => button.disabled);
        const giftInputs = [...root.querySelectorAll('input[name="trd_cart_gift_choice"]')];
        form.setAttribute('data-trd-cart-checking', '');
        root.setAttribute('aria-busy', 'true');
        checkoutButtons.forEach(button => button.disabled = true);
        giftInputs.forEach(input => input.disabled = true);
        retry.hidden = true;
        status.textContent = root.dataset.checking;
        try {
          const cart = await request('.js');
          const plan = planGift(cart, preferred, Date.now() <= Date.parse('2026-10-07T03:59:59Z'));
          let changed = false;
          const attributeValue = plan.optedOut && plan.allowed.length ? '1' : '';
          const attributeChanged = (cart.attributes?.[optOutKey] || '') !== attributeValue;
          if (Object.keys(plan.updates).length || attributeChanged) {
            await request('/update.js', { updates: plan.updates, attributes: { [optOutKey]: attributeValue } });
            changed = Object.keys(plan.updates).length > 0;
          }
          if (plan.add) { await request('/add.js', { items: [plan.add] }); changed = true; }
          let finalCart = changed ? await request('.js') : cart;
          const gift = finalCart.items.find(item => item.variant_id === plan.chosen && item.final_line_price === 0);
          if (plan.chosen && !gift) {
            const paidManaged = finalCart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
            if (paidManaged.length) await request('/update.js', { updates: Object.fromEntries(paidManaged.map(item => [item.key, 0])) });
            throw new Error(root.dataset.error);
          }
          const systemIds = new Set(Object.values(eligibility).flat());
          let staleSystem = finalCart.items.find(item => systemIds.has(item.variant_id) && item.properties?.['Free gift']);
          while (staleSystem) {
            const properties = { ...staleSystem.properties, _trd_yarbo_gift_note_migrated: '1' };
            delete properties['Free gift'];
            finalCart = await request('/change.js', { id: staleSystem.key, quantity: staleSystem.quantity, properties });
            if (finalCart.items.some(item => item.key === staleSystem.key && item.properties?.['Free gift'])) throw new Error(root.dataset.error);
            changed = true;
            staleSystem = finalCart.items.find(item => systemIds.has(item.variant_id) && item.properties?.['Free gift']);
          }
          needsReload = needsReload || changed;
          if (needsReload) {
            const note = form.querySelector('[name="note"]');
            if (note && note.value !== (finalCart.note || '')) await request('/update.js', { note: note.value });
            if (pendingPreference === undefined) window.location.reload();
            return false;
          }
          if (!plan.allowed.length) { root.hidden = true; return true; }
          root.removeAttribute('data-failed');
          status.textContent = plan.optedOut ? root.dataset.skipped : root.dataset.ready;
          root.querySelectorAll('input[name="trd_cart_gift_choice"]').forEach(input => input.checked = Number(input.value) === (plan.chosen || 0));
          return true;
        } catch (_) {
          root.setAttribute('data-failed', '');
          status.textContent = root.dataset.error;
          retry.hidden = false;
          return false;
        } finally {
          root.removeAttribute('aria-busy');
          form.removeAttribute('data-trd-cart-checking');
          checkoutButtons.forEach((button, index) => button.disabled = disabledBefore[index]);
          giftInputs.forEach(input => input.disabled = false);
          running = null;
          if (pendingPreference !== undefined) {
            const next = pendingPreference;
            pendingPreference = undefined;
            queueMicrotask(() => reconcile(next));
          }
        }
      })();
      return running;
    };
    root.addEventListener('change', event => {
      if (event.target.matches('input[name="trd_cart_gift_choice"]')) reconcile(Number(event.target.value));
    });
    retry.addEventListener('click', () => reconcile());
    const declineGift = event => {
      const row = event.target.closest('[data-cartitem]');
      if (!row || !giftIds.includes(Number(row.dataset.cartitemId))) return;
      const isRemove = event.type === 'click' && event.target.closest('[data-cartitem-remove]');
      const isZero = event.type === 'change' && event.target.matches('[data-quantity-input]') && event.target.value !== '' && Number(event.target.value) === 0;
      if (!isRemove && !isZero) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reconcile(0);
    };
    document.addEventListener('click', declineGift, true);
    document.addEventListener('change', declineGift, true);
    const guardCheckout = async event => {
      if (allowCheckout) return;
      const button = event.type === 'click' ? event.target.closest('button[name="checkout"]') : event.submitter;
      if (!button || button.form !== form || button.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (await reconcile()) { allowCheckout = true; form.requestSubmit(button); }
    };
    document.addEventListener('click', guardCheckout, true);
    document.addEventListener('submit', guardCheckout, true);
    const cartItems = form.querySelector('.cartitems--container');
    if (cartItems) new MutationObserver(() => {
      clearTimeout(queued);
      queued = setTimeout(() => reconcile(), 250);
    }).observe(cartItems, { childList: true, subtree: true });
    reconcile();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trd-yarbo-gift"] && !Shopify.designMode) return;
  try {
    if (!window.trdYarboGiftSubmitInstalled) {
    window.trdYarboGiftSubmitInstalled = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const offer = form.querySelector('[data-trd-gift]');
      if (!offer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.trdGiftBusy === 'true') return;
      const chosen = offer.querySelector('input[name="trd_gift_choice"]:checked, input[type="hidden"][name="trd_gift_choice"]');
      const error = offer.querySelector('[role="alert"]');
      const data = new FormData(form);
      const quantity = Number(data.get('quantity') || 1);
      const mainId = Number(data.get('id'));
      if (!chosen || !mainId || !Number.isInteger(quantity) || quantity < 1) {
        error.textContent = offer.dataset.error;
        error.hidden = false;
        return;
      }
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      properties['Free gift'] = chosen.dataset.giftName;
      const main = { id: mainId, quantity, properties };
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      const gift = { id: Number(chosen.value), quantity, properties: { '_trd_gift_for': String(mainId) } };
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const disabledBefore = buttons.map(button => button.disabled);
      form.dataset.trdGiftBusy = 'true';
      form.setAttribute('aria-busy', 'true');
      buttons.forEach(button => button.disabled = true);
      error.hidden = true;
      try {
        if (Date.now() > Date.parse('2026-10-07T03:59:59Z')) throw new Error(offer.dataset.expired);
        const cartResponse = await fetch(`${offer.dataset.cartUrl}.js`, { headers: { 'Accept': 'application/json' } });
        if (!cartResponse.ok) throw new Error(offer.dataset.error);
        const cart = await cartResponse.json();
        const giftIds = [50382698741974, 50382700085462];
        const existingGifts = cart.items.filter(item => giftIds.includes(item.variant_id) && item.properties && item.properties._trd_gift_for);
        const eligibility = {
  "50382698741974": [
    47259631845590,
    47259647410390,
    48360806580438,
    48360810938582,
    50409005121750,
    50409143730390,
    50409143828694,
    50409143861462,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ],
  "50382700085462": [
    47259649442006,
    48360804450518,
    48360806744278,
    48360811528406,
    50409005482198,
    50409005973718,
    50409143795926,
    50409145041110,
    48360800092374,
    48360806809814,
    48360811397334,
    48360812347606,
    50409005842646,
    50409006104790,
    50409144942806,
    50409145139414
  ]
};
        const systemIds = [...cart.items.map(item => item.variant_id), mainId];
        const keepGift = existingGifts.find(item => eligibility[item.variant_id].some(id => systemIds.includes(id)));
        const updates = {};
        existingGifts.forEach(item => {
          const wanted = item === keepGift ? 1 : 0;
          if (item.quantity !== wanted) updates[item.key] = wanted;
        });
        if (Object.keys(updates).length) {
          const updateResponse = await fetch(`${offer.dataset.cartUrl}/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
          });
          if (!updateResponse.ok) throw new Error(offer.dataset.error);
        }
        gift.quantity = 1;
        const items = keepGift ? [main] : [main, gift];
        if (keepGift) delete main.properties['Free gift'];
        const response = await fetch(`${offer.dataset.cartUrl}/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || offer.dataset.error);
        window.location.assign(offer.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || offer.dataset.error;
        error.hidden = false;
        error.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } finally {
        form.dataset.trdGiftBusy = 'false';
        form.removeAttribute('aria-busy');
        buttons.forEach((button, index) => button.disabled = disabledBefore[index]);
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
